const BREADCRUMB_MAP = {
  "/admin/dashboard": "活动数据监控 - 数据看板",
  "/admin/monitor/abandon": "活动数据监控 - 放弃创建",
  "/admin/settings": "系统管理 - 设置",
  "/admin/tables": "系统管理 - 表格",
  "/admin/maps": "系统管理 - 地图",
  "/admin/customers/users": "客户管理 - 用户列表",
  "/admin/customers/award-risk-whitelist": "客户管理 - 领奖风控白名单",
  "/admin/customers/authority": "客户管理 - 权限设置",
  "/admin/customers/activities": "活动管理 - 活动列表",
  "/admin/activities/recommendations": "活动管理 - 推荐活动",
  "/admin/customers/verification": "客户管理 - 认证申请",
  "/admin/customers/complaints": "活动管理 - 活动投诉",
  "/admin/orders/online-payment": "订单 - 线上支付订单",
  "/admin/materials/images": "运营素材管理 - 头图、奖品、背景",
  "/admin/materials/library": "运营素材管理 - 素材库",
  "/admin/materials/templates": "运营素材管理 - 活动模版",
  "/admin/materials/home-banner": "运营素材管理 - 首页 Banner",
  "/admin/cms/menus": "CMS - 菜单列表",
  "/admin/cms/articles": "CMS - 文章列表",
  "/admin/welfare/schedule": "官方每日福利 - 活动排期",
  "/admin/welfare/products": "官方每日福利 - 商品管理",
  "/admin/welfare/sponsors": "官方每日福利 - 赞助商管理",
};

export function getAdminBreadcrumbTitle(path) {
  if (path.startsWith("/admin/customers/verification/")) {
    return BREADCRUMB_MAP["/admin/customers/verification"];
  }

  if (path.startsWith("/admin/customers/authority/")) {
    return BREADCRUMB_MAP["/admin/customers/authority"];
  }

  return BREADCRUMB_MAP[path] || BREADCRUMB_MAP["/admin/dashboard"];
}
